import React, { Fragment } from 'react';

import classNames from 'classnames';

import { generateKey } from 'Helpers/misc';

import Tooltip from 'CommonComponents/Tooltip';

export default function EvaluationTemplateSummaryCompanyTable(props) {
    return (
        <div className="table__card">
            <h4 className="table__header tw-mb-6">
                {$t('Company')} - {props.company.name}
            </h4>
            <div id={`evaluation-templates-company-table-${props.company.id}`} className="inbud-table_wrapper">
                <table className="inbud-table tw-table-fixed">
                    <thead>
                        <tr>
                            <th></th>
                            <th className="tw-w-28">{$t('Weighting')}</th>
                            {props.scorers.map((scorer) => {
                                return (
                                    <th className="tw-w-56" key={generateKey()} colSpan={2}>
                                        {$t('Scorer')} / {scorer.user ? `${scorer.user?.first_name} ${scorer.user?.last_name}` : ''}
                                    </th>
                                );
                            })}

                            <th className="tw-w-56" colSpan={2}>
                                {$t('Average')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.items.map((item) => {
                            return (
                                <tr
                                    key={generateKey()}
                                    className={classNames({ '!tw-bg-white': item.type !== 'section', 'tw-font-semibold': item.type === 'section' })}
                                >
                                    <td>{item.name}</td>
                                    <td className={classNames({ 'tw-font-semibold': item.type === 'section' })}>{props.itemsWeighting[item.id]}%</td>

                                    {props.scorers.map((user) => {
                                        return (
                                            <Fragment key={generateKey()}>
                                                <td className={classNames({ 'tw-font-semibold': item.type === 'section' })}>
                                                    {item.type !== 'section' && (
                                                        <Tooltip
                                                            placement="top"
                                                            tooltipContent={props.data.data.items[item.id].data.scorers[user.id].description || ''}
                                                            tooltipType="text"
                                                        >
                                                            <div className="tw-cursor-pointer">
                                                                {props.data.data.items[item.id].data.scorers[user.id].score}
                                                            </div>
                                                        </Tooltip>
                                                    )}
                                                </td>
                                                <td className={classNames({ 'tw-font-semibold': item.type === 'section' })}>
                                                    {props.data.data.items[item.id].data.scorers[user.id].weighting}%
                                                </td>
                                            </Fragment>
                                        );
                                    })}
                                    <td className={classNames({ 'tw-font-semibold': item.type === 'section' })}>
                                        {item.type === 'section' ? '' : props.data.data.items[item.id].data.average.score}
                                    </td>
                                    <td className={classNames({ 'tw-font-semibold': item.type === 'section' })}>
                                        {props.data.data.items[item.id].data.average.weighting}%
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>Total</td>
                            <td>{props.itemsWeighting.total}%</td>
                            {props.scorers.map((user) => {
                                return (
                                    <Fragment key={generateKey()}>
                                        <td />
                                        <td>{props.data.data.scorers[user.id].average.weighting}%</td>
                                    </Fragment>
                                );
                            })}
                            <td></td>
                            <td>{props.data.average.weighting}%</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
}
